import { useEffect } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

/**
 * Route guard. Renders <Outlet /> if authenticated, redirects to /login
 * otherwise. Hydrates the auth store from localStorage on first mount.
 */
export default function RequireAuth() {
  const loc = useLocation()
  const hydrated = useAuthStore((s) => s.hydrated)
  const token = useAuthStore((s) => s.token)
  const hydrate = useAuthStore((s) => s.hydrate)

  useEffect(() => {
    if (!hydrated) hydrate()
  }, [hydrated, hydrate])

  if (!hydrated) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground font-mono text-sm">
        Loading…
      </div>
    )
  }

  if (!token) {
    const next = encodeURIComponent(loc.pathname + loc.search)
    return <Navigate to={`/login?next=${next}`} replace />
  }

  return <Outlet />
}
